import ModelPrototype, { Method } from "@models/ModelPrototype";

export default class UserRating extends ModelPrototype {
  public async get(): Promise<{ data: any }> {
    try {
      return this.withUrl(`user/rating`).setMethod(Method.GET).request();
    } catch (Exception) {
      throw Exception;
    }
  }
}
